<template>
    <div class="assessment " :class="{'assessmentPC':$store.state.innerWidth>768}">
       <Breadcrumbs></Breadcrumbs>
       <div class="assessment-content assessment-mb">
           <div class="assessment-pc">
               <h2 class="Bold center">{{$t('message.Self-Assessment')}}</h2>
               <p class="center desc">{{$t('message.assessmentDesc')}}</p>
           </div>
       </div>
       <div class="assessment-content assessment-mb">
           <div class="assessment-pc">
              <div class="row">
                <div class="col-sm-4 group">
                   <div class="btnGroup ">
                      <div class="tit">
                       <h4 class="SemiBold">{{$t('message.Skill-Career Quiz')}}</h4>
                      </div>
                      <div>
                       <img src="../images/assessment/List_Skills1.png" :alt="$t('message.Skill-Career Quiz')" />
                      </div>
                      <div style="padding: 30px">
                       <div class="btn btn-primary" @click="goSkills()" role="button" :aria-label='$t("message.getStarted")'>
                         <a href="javascript:;" style="color: inherit">{{$t("message.getStarted")}}</a>
                        </div>
                      </div>
                   </div>
                </div>
                <div  class="col-sm-4 group">
                 <div class="btnGroup ">
                  <div class="tit">
                    <h4 class="SemiBold">{{$t('message.Interest-Career Quiz')}}</h4>
                  </div>
                  <div>
                    <img src="../images/assessment/List_Interest2.png" :alt="$t('message.Interest-Career Quiz')" />
                  </div>
                  <div style="padding: 30px">
                    <div class="btn btn-primary" @click="goInterest()" role="button" :aria-label='$t("message.getStarted")'>
                      <a href="javascript:;" style="color: inherit">{{$t("message.getStarted")}}</a>
                    </div>
                  </div>
                 </div>
               </div>
               <div  class="col-sm-4 group">
                 <div class="btnGroup">
                      <div class="tit">
                     <h4 class="SemiBold">{{$t('message.Background-Career Quiz')}}</h4>
                      </div>
                      <div>
                     <img src="../images/assessment/List_background3.png" :alt="$t('message.Background-Career Quiz')" />
                      </div>
                      <div style="padding: 30px">
                     <div class="btn btn-primary" @click="goBackground()" role="button" :aria-label='$t("message.getStarted")'>
                      <a href="javascript:;" style="color: inherit">{{$t("message.getStarted")}}</a>
                     </div>
                      </div>
                 </div>
               </div>
              </div>
           </div>
       </div>
       <div class="bgImage">
         <img class="bgImg1 noSelect" src="../images/deco-28.png" />
         <img class="bgImg2 noSelect" src="../images/deco-06.png" />
         <img class="bgImg3 noSelect" src="../images/deco-21.png" />
       </div>
          <a class="displayA" v-bind:href="'./selfSkillInfo?lang='+$store.state.language"></a>
          <a class="displayA" v-bind:href="'./InterestAssessment?lang='+$store.state.language"></a>
          <a class="displayA" v-bind:href="'./backgroundInfo?lang='+$store.state.language"></a>
    </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import { EventBus } from "@/javascripts/eventBus.js";
export default {
    components: {
       Breadcrumbs
    },
    data() {
        return {
        }
    },   
    created(){
    },
    props: ["logGaEvent"],
    methods: {
        goSkills(){
          this.logGaEvent('userClick','selfAssessment',"selfSkillInfo")
          this.$router.push({ path: '/selfSkillInfo' , query:{lang:this.$store.state.language}});
           window.scrollTo(0, 0);
        },
        goInterest(){
          this.logGaEvent('userClick','selfAssessment',"InterestAssessment")
            this.$router.push({ path: '/InterestAssessment' , query:{lang:this.$store.state.language}});
             window.scrollTo(0, 0);
        },
        goBackground(){
          this.logGaEvent('userClick','selfAssessment',"backgroundInfo")
            this.$router.push({ path: '/backgroundInfo' , query:{lang:this.$store.state.language}});
             window.scrollTo(0, 0);
        }
    },
    mounted() {
        var that = this;
      // EventBus.$emit('error', { errMsg: this.$i18n.t("message.developmentTip")})
        setTimeout(function(){
          that.$store.state.mate.title = that.$i18n.t("message.Self-Assessment_title")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
          that.$store.state.mate.keywords = that.$i18n.t("message.Self-Assessment_keywords");
        })
        this.$store.state.mate.description = this.$i18n.t("message.Self-Assessment_desc");
        this.$store.state.selectMenu =5;
    }


   
}
</script>